"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_Twitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "D94C333B-91A3-4AA6-90C7-4323628984D1"), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-79.000000, -646.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-/-Twitter-/-App-Launcher",
    transform: "translate(79.000000, 646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter_Social_Icon_Rounded_Square_Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dark_Blue",
    fill: "#1DA1F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,32 L4,32 C1.792,32 0,30.208 0,28 L0,4 C0,1.792 1.792,0 4,0 L28,0 C30.208,0 32,1.792 32,4 L32,28 C32,30.208 30.208,32 28,32 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo__x2014__FIXED",
    transform: "translate(6.000000, 7.840000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.288,16.288 C13.832,16.288 17.96,10.032 17.96,4.616 C17.96,4.44 17.96,4.264 17.952,4.088 C18.752,3.512 19.448,2.784 20,1.96 C19.264,2.288 18.472,2.504 17.64,2.608 C18.488,2.104 19.136,1.296 19.448,0.336 C18.656,0.808 17.776,1.144 16.84,1.328 C16.088,0.528 15.024,0.032 13.848,0.032 C11.584,0.032 9.744,1.872 9.744,4.136 C9.744,4.456 9.784,4.768 9.848,5.072 C6.44,4.904 3.416,3.264 1.392,0.784 C1.04,1.392 0.84,2.096 0.84,2.848 C0.84,4.272 1.568,5.528 2.664,6.264 C1.992,6.24 1.36,6.056 0.808,5.752 C0.808,5.768 0.808,5.784 0.808,5.808 C0.808,7.792 2.224,9.456 4.096,9.832 C3.752,9.928 3.392,9.976 3.016,9.976 C2.752,9.976 2.496,9.952 2.248,9.904 C2.768,11.536 4.288,12.72 6.08,12.752 C4.672,13.856 2.904,14.512 0.984,14.512 C0.656,14.512 0.328,14.496 0.008,14.456 C1.816,15.608 3.976,16.288 6.288,16.288",
    id: "Path"
  })))))));
}

var _default = ic_Twitter;
exports.default = _default;